/** Infer the opponent's side from the creator's custom prop pick. */
export function inferOpponentSide(creatorSide) {
  const trimmed = (creatorSide || '').trim();
  if (!trimmed) return '';
  const overMatch = trimmed.match(/^over\s+(.+)$/i);
  if (overMatch) return `Under ${overMatch[1]}`;
  const underMatch = trimmed.match(/^under\s+(.+)$/i);
  if (underMatch) return `Over ${underMatch[1]}`;
  return `Not: ${trimmed}`;
}
